import { Box, Flex } from '@chakra-ui/react';
import _ from 'lodash';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateComponent } from '../../redux/pagesSlice';
import { selectComponent, selectedComponent } from '../../redux/selectedComponentSlice';
import { selectedPage } from '../../redux/selectedPageSlice';
import { findCompByIdRecursively } from '../../utils/functions';

const EditorTitleInput = ({ componentId, titleValue }) => {
	const [value, setValue] = React.useState(titleValue);
	const selectedComponentValue = useSelector(selectedComponent);
	const selectedPageValue = useSelector(selectedPage);
	const dispatch = useDispatch();
	const debounceFn = useCallback(_.debounce(handlePagesUpdate, 250), [
		selectedPageValue,
		componentId,
		selectedComponentValue,
	]);

	function handlePagesUpdate(value) {
		const newSelectedComponent = JSON.parse(JSON.stringify(selectedComponentValue));
		const { comp } = findCompByIdRecursively(
			[newSelectedComponent.childComp ?? newSelectedComponent.props],
			componentId,
		);
		comp.title = value;
		//check if value exists, if exists, set comp.title, if not, set undefined
		if (value) {
			comp.title = value;
		} else {
			comp.title = undefined;
		}
		comp.props.mzTitle = value;

		dispatch(
			updateComponent({
				component: comp,
				componentId,
				pageId: selectedPageValue,
			}),
		);

		if (newSelectedComponent?.childComp) {
			const { comp: originalComp } = findCompByIdRecursively([newSelectedComponent?.props], componentId);
			originalComp.title = value;
		}

		dispatch(selectComponent(newSelectedComponent));
	}

	function handleChange(e) {
		// setCaretPos(e.target.selectionEnd)
		const value = e.target.value;
		setValue(value);
		debounceFn(value);
	}
	return (
		<Flex className="mz-hef-edit" flex={'1 1 49%'} maxW={'49%'} flexDir="column">
			<label>
				<Box display={'inline-block'}>Site Editor Title</Box>
			</label>
			<input
				onChange={(e) => {
					handleChange(e);
				}}
				value={value || ''}
				placeholder={''}
			/>
		</Flex>
	);
};

export default EditorTitleInput;
